const isLive = process.env.REACT_APP_IS_LIVE;
const stripeKey = (isLive === "yes") ? process.env.REACT_APP_STRIPE_LIVE_KEY : process.env.REACT_APP_STRIPE_TEST_KEY;
export default {
    ZAP_URL: process.env.REACT_APP_ZAP_URL,
    STRIPE_API_KEY: stripeKey,
};